const InfoBulleReference = (fetchLexiqueSlug, lexiconElementsRef, id) => {
  const desc = (document.getElementById(id));
  const lexiconElements = desc.querySelectorAll('.lexicon-element');
  if (lexiconElements.length !== 0) {
    lexiconElements.forEach((elem) => {
      const dataLexiconSlug = elem.getAttribute('data-lexicon-slug');
      elem.setAttribute('id', dataLexiconSlug);
      fetchLexiqueSlug(dataLexiconSlug);
      if (elem && !lexiconElementsRef.includes(elem)) {
        lexiconElementsRef.push(elem);
      }
    });
  }
};
export default InfoBulleReference;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/InfoBulleReference.js